module.exports = __webpack_public_path__ + "img/banner2.6a01d620.png";